module.exports = __webpack_public_path__ + "img/pr.130ad02e.svg";